export type LangKey =
  | 'pageTitle'
  | 'breadcrumb.configurations'
  | 'breadcrumb.deliveryRpm'
  | 'tabs.haulbacks'
  | 'tabs.routeRoadblocks'
  | 'addButton.haulback'
  | 'addButton.route'
  | 'table.reasonCode'
  | 'table.icon'
  | 'table.displayOrder'
  | 'table.locationType'
  | 'table.orgType'
  | 'table.3pl'
  | 'table.duo'
  | 'table.active'
  | 'button.cancel'
  | 'button.save'
  | 'toast.error'
  | 'modal.addTitle'
  | 'modal.editTitle'
  | 'pagination.rowsPerPage'
  | 'summary.showing'
  | 'button.clearFilters'
  | 'empty.noRecords'
  | 'empty.noRecordsFilters'
  | 'modal.form.reasonCode'
  | 'modal.form.displayOrder'
  | 'modal.form.reasonCodeCategory'
  | 'modal.form.placeholder'
  | 'validation.completeTranslations'
  | 'toast.addSuccess'
  | 'toast.updateSuccess'
  | 'table.roadblockType'
  | 'table.routeRoadblock'
  | 'modal.route.addTitle'
  | 'modal.route.editTitle'
  | 'summary.showingRoute'
  | 'empty.noRecordsRoute'
  | 'modal.form.roadblockType'
  | 'modal.form.routeRoadblock'
  | 'modal.form.routeRoadblockPlaceholder'
  | 'modal.form.locationType'
  | 'modal.form.orgType'
  | 'modal.form.3plStatus'
  | 'modal.form.duoStatus'
  | 'modal.form.icon'
  | 'modal.form.iconPlaceholder'
  | 'modal.form.iconEmptyHint'
  | 'modal.form.optionalFields'
  | 'modal.form.pictureRequirement'
  | 'modal.form.textField'
  | 'modal.form.noByDefault'
  | 'modal.form.selectPlaceholder'
  | 'modal.form.selectAll'
  | 'modal.form.clearAll'
  | 'roadblockType.stopIssue'
  | 'roadblockType.routeIssue'
  | 'validation.reasonCodeDuplicate'
  | 'validation.displayOrderDuplicate'
  | 'validation.roadblockDuplicate'
  | 'validation.roadblockMaxLen'
  | 'toast.routeAddSuccess'
  | 'toast.routeUpdateSuccess'
  | 'modal.unsaved.title'
  | 'modal.unsaved.message'
  | 'modal.unsaved.confirm'
  | 'modal.unsaved.cancel'
  | 'label.active'
  | 'label.disabled'
  | 'category.delivery'
  | 'category.equipment'
  | 'category.sales'
  | 'category.warehouse'
  | 'pagination.page'
  | 'pagination.of'
  | 'pagination.first'
  | 'pagination.previous'
  | 'pagination.next'
  | 'pagination.last'
  | 'modal.form.photoFieldLabel'
  | 'modal.form.textFieldLabel'
  | 'validation.photoFieldLabelRequired'
  | 'validation.textFieldLabelRequired'
  | 'validation.fieldLabelAllLanguagesRequired';

const TRANSLATIONS: Record<string, Record<LangKey, string>> = {
  en: {
    pageTitle: 'Delivery RPM Management',
    'breadcrumb.configurations': 'Configurations',
    'breadcrumb.deliveryRpm': 'Delivery RPM Management',
    'tabs.haulbacks': 'Haulbacks',
    'tabs.routeRoadblocks': 'Route Roadblocks',
    'addButton.haulback': 'Create New Reason Code',
    'addButton.route': 'Create New Route Roadblock',
    'table.reasonCode': 'Reason Code',
    'table.icon': 'Icon',
    'table.displayOrder': 'Display Order',
    'table.locationType': 'Location Type',
    'table.orgType': 'Org Type',
    'table.3pl': '3PL Status',
    'table.duo': 'Duo Status',
    'table.active': 'Active/Disabled',
    'button.cancel': 'Cancel',
    'button.save': 'Save',
    'toast.error': 'Error',
    'modal.addTitle': 'Add Reason Code',
    'modal.editTitle': 'Edit Reason Code',
    'pagination.rowsPerPage': 'Rows per page',
    'label.active': 'Active',
    'label.disabled': 'Disabled',
    'category.delivery': 'Delivery',
    'category.equipment': 'Equipment',
    'category.sales': 'Sales',
    'category.warehouse': 'Warehouse',
    'pagination.page': 'Page',
    'pagination.of': 'of',
    'pagination.first': 'First page',
    'pagination.previous': 'Previous page',
    'pagination.next': 'Next page',
    'pagination.last': 'Last page',
    'summary.showing': 'Showing {countFiltered} of {countTotal} Haulback Reason Codes',
    'button.clearFilters': 'Clear All Filters',
    'empty.noRecords': "No haulback reason codes configured. Click 'Create New Reason Code' to add one.",
    'empty.noRecordsFilters': 'No records match the active filters.',
    'modal.form.reasonCode': 'Reason Code',
    'modal.form.displayOrder': 'Display Order',
    'modal.form.reasonCodeCategory': 'Reason Code Category',
    'modal.form.placeholder': 'e.g. Customer Refused',
    'validation.completeTranslations': 'Please complete translations for all languages before saving.',
    'toast.addSuccess': 'Haulback reason code created successfully.',
    'toast.updateSuccess': 'Haulback reason code updated successfully.',
    'table.roadblockType': 'Roadblock Type',
    'table.routeRoadblock': 'Route Roadblock',
    'modal.route.addTitle': 'Create New Route Roadblock',
    'modal.route.editTitle': 'Edit Route Roadblock',
    'summary.showingRoute': 'Showing {countFiltered} of {countTotal} Route Roadblocks',
    'empty.noRecordsRoute': "No route roadblocks configured. Click 'Create New Route Roadblock' to add one.",
    'modal.form.roadblockType': 'Roadblock Type',
    'modal.form.routeRoadblock': 'Route Roadblock',
    'modal.form.routeRoadblockPlaceholder': 'e.g. Locked Gate',
    'modal.form.locationType': 'Location Type',
    'modal.form.orgType': 'Org Type',
    'modal.form.3plStatus': '3PL Status',
    'modal.form.duoStatus': 'Duo Status',
    'modal.form.icon': 'Icon',
    'modal.form.iconPlaceholder': 'Enter emoji or material icon name',
    'modal.form.iconEmptyHint': 'No material icons found. Keep typed value to save custom/emoji icon.',
    'modal.form.optionalFields': 'Optional Additional Fields',
    'modal.form.pictureRequirement': 'Picture Requirement',
    'modal.form.textField': 'Text Field',
    'modal.form.noByDefault': '(No by default)',
    'modal.form.selectPlaceholder': 'Select…',
    'modal.form.selectAll': 'Select All',
    'modal.form.clearAll': 'Clear All',
    'roadblockType.stopIssue': 'Stop Issue',
    'roadblockType.routeIssue': 'Route Issue',
    'validation.reasonCodeDuplicate': 'A haulback reason code with this name already exists.',
    'validation.displayOrderDuplicate': 'A haulback reason code with this display order already exists.',
    'validation.roadblockDuplicate': 'A route roadblock with this type and name already exists.',
    'validation.roadblockMaxLen': 'Route Roadblock cannot exceed 100 characters.',
    'toast.routeAddSuccess': 'Route roadblock created successfully.',
    'toast.routeUpdateSuccess': 'Route roadblock updated successfully.',
    'modal.unsaved.title': 'Discard changes?',
    'modal.unsaved.message': 'You have unsaved changes. Are you sure you want to discard them?',
    'modal.unsaved.confirm': 'Confirm',
    'modal.unsaved.cancel': 'Cancel',
    'modal.form.photoFieldLabel': 'Photo Field Label',
    'modal.form.textFieldLabel': 'Text Field Label',
    'validation.photoFieldLabelRequired': 'Photo field label is required in English.',
    'validation.textFieldLabelRequired': 'Text field label is required in English.',
    'validation.fieldLabelAllLanguagesRequired': 'All 3 languages (English, French, Spanish) are required for field labels.',
  },
  fr: {
    pageTitle: 'Gestion RPM de Livraison',
    'breadcrumb.configurations': 'Configurations',
    'breadcrumb.deliveryRpm': 'Gestion RPM de Livraison',
    'tabs.haulbacks': 'Rapatriements',
    'tabs.routeRoadblocks': 'Blocages Routiers',
    'addButton.haulback': 'Créer un nouveau code raison',
    'addButton.route': 'Créer un nouveau blocage de route',
    'table.reasonCode': 'Code Raison',
    'table.icon': 'Icône',
    'table.displayOrder': 'Ordre d’affichage',
    'table.locationType': 'Type d’emplacement',
    'table.orgType': 'Type d’organisation',
    'table.3pl': 'Statut 3PL',
    'table.duo': 'Statut Duo',
    'table.active': 'Actif/Désactivé',
    'button.cancel': 'Annuler',
    'button.save': 'Enregistrer',
    'toast.error': 'Erreur',
    'modal.addTitle': 'Ajouter un code raison',
    'modal.editTitle': 'Modifier le code raison',
    'pagination.rowsPerPage': 'Lignes par page',
    'label.active': 'Actif',
    'label.disabled': 'Désactivé',
    'category.delivery': 'Livraison',
    'category.equipment': 'Équipement',
    'category.sales': 'Ventes',
    'category.warehouse': 'Entrepôt',
    'pagination.page': 'Page',
    'pagination.of': 'sur',
    'pagination.first': 'Première page',
    'pagination.previous': 'Page précédente',
    'pagination.next': 'Page suivante',
    'pagination.last': 'Dernière page',
    'summary.showing': 'Affichage de {countFiltered} sur {countTotal} codes raison',
    'button.clearFilters': 'Effacer tous les filtres',
    'empty.noRecords': "Aucun code raison de rapatriement configuré. Cliquez sur 'Ajouter le code raison' pour en ajouter un.",
    'empty.noRecordsFilters': 'Aucun enregistrement ne correspond aux filtres actifs.',
    'modal.form.reasonCode': 'Code Raison',
    'modal.form.displayOrder': 'Ordre d’affichage',
    'modal.form.reasonCodeCategory': 'Catégorie du code raison',
    'modal.form.placeholder': 'ex. Refus du client',
    'validation.completeTranslations': 'Veuillez remplir les traductions pour toutes les langues avant d’enregistrer.',
    'toast.addSuccess': 'Le code raison a été créé avec succès.',
    'toast.updateSuccess': 'Le code raison a été mis à jour avec succès.',
    'table.roadblockType': 'Type de blocage',
    'table.routeRoadblock': 'Blocage de route',
    'modal.route.addTitle': 'Créer un nouveau blocage de route',
    'modal.route.editTitle': 'Modifier le blocage de route',
    'summary.showingRoute': 'Affichage de {countFiltered} sur {countTotal} blocages de route',
    'empty.noRecordsRoute': "Aucun blocage de route configuré. Cliquez sur 'Créer un nouveau blocage de route' pour en ajouter un.",
    'modal.form.roadblockType': 'Type de blocage',
    'modal.form.routeRoadblock': 'Blocage de route',
    'modal.form.routeRoadblockPlaceholder': 'ex. Portail verrouillé',
    'modal.form.locationType': 'Type d’emplacement',
    'modal.form.orgType': 'Type d’organisation',
    'modal.form.3plStatus': 'Statut 3PL',
    'modal.form.duoStatus': 'Statut Duo',
    'modal.form.icon': 'Icône',
    'modal.form.iconPlaceholder': 'Entrez un emoji ou un nom d’icône material',
    'modal.form.iconEmptyHint': 'Aucune icône material trouvée. Conservez la valeur saisie pour enregistrer une icône personnalisée/emoji.',
    'modal.form.optionalFields': 'Champs supplémentaires facultatifs',
    'modal.form.pictureRequirement': 'Exigence de photo',
    'modal.form.textField': 'Champ de texte',
    'modal.form.noByDefault': '(Non par défaut)',
    'modal.form.selectPlaceholder': 'Sélectionner…',
    'modal.form.selectAll': 'Tout sélectionner',
    'modal.form.clearAll': 'Tout effacer',
    'roadblockType.stopIssue': 'Problème d’arrêt',
    'roadblockType.routeIssue': 'Problème de route',
    'validation.reasonCodeDuplicate': 'Un code raison de rapatriement avec ce nom existe déjà.',
    'validation.displayOrderDuplicate': 'Un code raison de rapatriement avec cet ordre d’affichage existe déjà.',
    'validation.roadblockDuplicate': 'Un blocage de route avec ce type et ce nom existe déjà.',
    'validation.roadblockMaxLen': 'Le blocage de route ne peut pas dépasser 100 caractères.',
    'toast.routeAddSuccess': 'Blocage de route créé avec succès.',
    'toast.routeUpdateSuccess': 'Blocage de route mis à jour avec succès.',
    'modal.unsaved.title': 'Abandonner les modifications ?',
    'modal.unsaved.message': 'Vous avez des modifications non enregistrées. Voulez-vous vraiment les abandonner ?',
    'modal.unsaved.confirm': 'Confirmer',
    'modal.unsaved.cancel': 'Annuler',    'modal.form.photoFieldLabel': 'Étiquette du champ photo',
    'modal.form.textFieldLabel': 'Étiquette du champ texte',
    'validation.photoFieldLabelRequired': 'Létiquette du champ photo est requise en anglais.',
    'validation.textFieldLabelRequired': 'Létiquette du champ texte est requise en anglais.',
    'validation.fieldLabelAllLanguagesRequired': 'Les 3 langues (anglais, français, espagnol) sont requises pour les étiquettes de champ.',  },
  es: {
    pageTitle: 'Administración RPM de Entrega',
    'breadcrumb.configurations': 'Configuraciones',
    'breadcrumb.deliveryRpm': 'Administración RPM de Entrega',
    'tabs.haulbacks': 'Regresadas',
    'tabs.routeRoadblocks': 'Obstáculos en la Ruta',
    'addButton.haulback': 'Crear nuevo código de razón',
    'addButton.route': 'Crear nuevo obstáculo de ruta',
    'table.reasonCode': 'Código de Razón',
    'table.icon': 'Icono',
    'table.displayOrder': 'Orden de visualización',
    'table.locationType': 'Tipo de ubicación',
    'table.orgType': 'Tipo de organización',
    'table.3pl': 'Estado 3PL',
    'table.duo': 'Estado Duo',
    'table.active': 'Activo/Deshabilitado',
    'button.cancel': 'Cancelar',
    'button.save': 'Guardar',
    'toast.error': 'Error',
    'modal.addTitle': 'Agregar código de razón',
    'modal.editTitle': 'Editar código de razón',
    'pagination.rowsPerPage': 'Filas por página',
    'label.active': 'Activo',
    'label.disabled': 'Deshabilitado',
    'category.delivery': 'Entrega',
    'category.equipment': 'Equipo',
    'category.sales': 'Ventas',
    'category.warehouse': 'Almacén',
    'pagination.page': 'Página',
    'pagination.of': 'de',
    'pagination.first': 'Primera página',
    'pagination.previous': 'Página anterior',
    'pagination.next': 'Página siguiente',
    'pagination.last': 'Última página',
    'summary.showing': 'Mostrando {countFiltered} de {countTotal} códigos de razón',
    'button.clearFilters': 'Borrar todos los filtros',
    'empty.noRecords': "No hay códigos de razón configurados. Haga clic en 'Agregar código de razón' para agregar uno.",
    'empty.noRecordsFilters': 'No hay registros que coincidan con los filtros activos.',
    'modal.form.reasonCode': 'Código de Razón',
    'modal.form.displayOrder': 'Orden de visualización',
    'modal.form.reasonCodeCategory': 'Categoría del código de razón',
    'modal.form.placeholder': 'p.ej. Rechazo del cliente',
    'validation.completeTranslations': 'Por favor complete las traducciones para todos los idiomas antes de guardar.',
    'toast.addSuccess': 'Código de razón creado con éxito.',
    'toast.updateSuccess': 'Código de razón actualizado con éxito.',
    'table.roadblockType': 'Tipo de obstáculo',
    'table.routeRoadblock': 'Obstáculo de ruta',
    'modal.route.addTitle': 'Crear nuevo obstáculo de ruta',
    'modal.route.editTitle': 'Editar obstáculo de ruta',
    'summary.showingRoute': 'Mostrando {countFiltered} de {countTotal} obstáculos de ruta',
    'empty.noRecordsRoute': "No hay obstáculos de ruta configurados. Haga clic en 'Crear nuevo obstáculo de ruta' para agregar uno.",
    'modal.form.roadblockType': 'Tipo de obstáculo',
    'modal.form.routeRoadblock': 'Obstáculo de ruta',
    'modal.form.routeRoadblockPlaceholder': 'p.ej. Puerta cerrada con llave',
    'modal.form.locationType': 'Tipo de ubicación',
    'modal.form.orgType': 'Tipo de organización',
    'modal.form.3plStatus': 'Estado 3PL',
    'modal.form.duoStatus': 'Estado Duo',
    'modal.form.icon': 'Icono',
    'modal.form.iconPlaceholder': 'Ingrese un emoji o nombre de icono material',
    'modal.form.iconEmptyHint': 'No se encontraron iconos material. Mantenga el valor escrito para guardar un icono personalizado/emoji.',
    'modal.form.optionalFields': 'Campos adicionales opcionales',
    'modal.form.pictureRequirement': 'Requisito de foto',
    'modal.form.textField': 'Campo de texto',
    'modal.form.noByDefault': '(No por defecto)',
    'modal.form.selectPlaceholder': 'Seleccionar…',
    'modal.form.selectAll': 'Seleccionar todo',
    'modal.form.clearAll': 'Borrar todo',
    'roadblockType.stopIssue': 'Problema de parada',
    'roadblockType.routeIssue': 'Problema de ruta',
    'validation.reasonCodeDuplicate': 'Ya existe un código de razón de retorno con este nombre.',
    'validation.displayOrderDuplicate': 'Ya existe un código de razón de retorno con este orden de visualización.',
    'validation.roadblockDuplicate': 'Ya existe un obstáculo de ruta con este tipo y nombre.',
    'validation.roadblockMaxLen': 'El obstáculo de ruta no puede exceder 100 caracteres.',
    'toast.routeAddSuccess': 'Obstáculo de ruta creado con éxito.',
    'toast.routeUpdateSuccess': 'Obstáculo de ruta actualizado con éxito.',
    'modal.unsaved.title': '¿Descartar cambios?',
    'modal.unsaved.message': 'Tiene cambios sin guardar. ¿Está seguro de que desea descartarlos?',
    'modal.unsaved.confirm': 'Confirmar',
    'modal.unsaved.cancel': 'Cancelar',
    'modal.form.photoFieldLabel': 'Etiqueta del campo de foto',
    'modal.form.textFieldLabel': 'Etiqueta del campo de texto',
    'validation.photoFieldLabelRequired': 'La etiqueta del campo de foto es obligatoria en inglés.',
    'validation.textFieldLabelRequired': 'La etiqueta del campo de texto es obligatoria en inglés.',
    'validation.fieldLabelAllLanguagesRequired': 'Se requieren los 3 idiomas (inglés, francés, español) para las etiquetas de campo.',
  },
};

export const t = (lang: string | undefined, key: LangKey) => {
  const l = (lang && TRANSLATIONS[lang]) ? lang : 'en';
  return TRANSLATIONS[l][key] ?? TRANSLATIONS.en[key];
};

export default TRANSLATIONS;
